import React from 'react';
import { motion } from "framer-motion";

const AnimateComponent = (props) => {
    console.log(props);
    return (
        <motion.div
            initial={{ opacity: 0, transform: `translateY(240px)` }}
            whileInView={{ opacity: 1, transform: `translateY(0px)` }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
            {...props}
        >
            {props.children}
        </motion.div>
    );
};
export default AnimateComponent;
